<template>
  <div class="animated fadeIn payments">
    <!-- payment-dialog -->
    <new-payment
      v-if="newPaymentOpen"
      :dialog="newDialog"
      @submitPayment="addPayment()"
      @closeDialog="closeNewPayment()"
    />

    <!-- editPayment-dialog -->
    <payment-details
      v-if="editPaymentOpen"
      :selectedId="selectedId"
      :detailsDialog="detailsDialog"
      @closeDetailsDialog="closeDetailsDialog()"
      @submitEditDialog="submitEditDialog()"
    />
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">لیست پرداخت‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌ها</h4>
      </div>
      <hr class="mt-5" />
      <v-card class="text-center pb-12" v-if="isBusy">
        <cube></cube>
        <span style="font-size: 16px">در حال بارگذاری ...</span>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col cols="12" md="6" class="d-flex flex-row">
              <h4 class="c-purple">لیست پرداخت‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌های فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4"
                >({{ computedPayments.length }} پرداخت)</span
              >
            </v-col>
            <v-col class="text-left">
              <v-btn
                @click="openPayModal()"
                class="purple-borderedBtn"
                height="43"
                style="text-decoration: none"
              >
                <v-icon class="me-1">$Wallet</v-icon>افزودن پرداخت جدید
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col class="c-grey d-flex flex-row flex-wrap">
              <div class="custom-input d-flex flex-row flex-wrap">
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="$Search"
                  hide-details
                  label="جستجو در کد پرداخت..."
                  color="#4ba0e7"
                  @input="currentPage = 1"
                  v-model="codeFilter"
                  class="me-3 mt-2"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="codeFilter.length"
                      class="red--text text--lighten-2 mt-1"
                      @click="
                        codeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="$Search"
                  hide-details
                  label="جستجو در نام مشتری..."
                  color="#4ba0e7"
                  v-model="nameFilter"
                  @input="currentPage = 1"
                  class="me-3 mt-2"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="nameFilter.length"
                      class="red--text text--lighten-2 mt-1"
                      @click="
                        nameFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
              <div class="customSelect2 me-3 pb-0 mt-2">
                <span class="c-blue pt-3 pe-2"> فیلتر وضعیت </span>
                <v-select
                  attach
                  class="shop-select"
                  :menu-props="{ bottom: true, offsetY: true }"
                  dense
                  outlined
                  hide-details
                  :items="types"
                  v-model="typeFilter"
                  @change="currentPage = 1"
                >
                  <template v-slot:append>
                    <v-icon class="c-blue">$ArrowDown</v-icon>
                  </template>
                </v-select>
              </div>
              <MyCalendar
                @submit="searchPayments()"
                @getStartDate="getStartDate"
                @getEndDate="getEndDate"
                :label="'فیلتر زمانی'"
                :icon="'arrow'"
                :start="startDate"
                :end="endDate"
                class="mt-2"
              />
            </v-col>
          </v-row>
          <hr class="mt-5" />
          <vue-excel-xlsx
            :data="computedPayments"
            :columns="excelFields"
            class="darkGreen-mainBtn mb-4 float-start"
            style="width: 135px; height: 35px"
            file-name="لیست_پرداخت‌ها"
            sheet-name="لیست_پرداخت‌‌‌ها"
            :class="computedPayments.length ? 'white--text' : 'disabled-excel'"
          >
            <v-icon
              :class="computedPayments.length ? 'white--text' : ''"
              class="me-1"
              >mdi-file-excel-outline</v-icon
            >
            خروجی اکسل
          </vue-excel-xlsx>
          <v-btn
            :disabled="gettingReceipt || !computedPayments.length"
            class="darkRed-mainBtn white--text mb-4 float-end"
            style="width: 135px; height: 35px"
            @click="printReceipt()"
            depressed
            ><v-icon class="me-1">mdi-printer</v-icon>پرینت</v-btn
          >
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedPayments"
              :fields="paymentsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              class="middle"
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:cell(amount)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() + " ریال" }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell(shopCustomerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    target="_blank"
                    :href="'/shop/customer/' + data.item.shopCustomerId"
                    >{{ data.value }}</a
                  >
                </div>
              </template>
              <template v-slot:cell(description)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{
                    data.value.length > 35
                      ? data.value.slice(0, 35) + "..."
                      : data.value
                  }}
                </div>
              </template>

              <template v-slot:cell(operation)="data">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    @click="openDetailsDialog(data.item.id)"
                    class="purple-mainBtn"
                    width="140"
                    height="40"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده جزئیات</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6" v-if="computedPayments.length">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      attach
                      class="shop-select"
                      :menu-props="{ bottom: true, offsetY: true }"
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedPayments.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
    <br />
    <router-view></router-view>

    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">لیست پرداخت‌ها</h3>
      <b-table :items="computedPayments" :fields="paymentsFieldsPrint">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import MyCalendar from "../../components/MyCalendar.vue";
import NewPayment from "../../components/NewPayment.vue";
import PaymentDetails from "../../components/PaymentDetails.vue";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    MyCalendar,
    NewPayment,
    PaymentDetails,
  },

  data: function () {
    return {
      editPaymentOpen: false,
      newPaymentOpen: false,
      reactivity: false,
      isLoaded: false,
      loading: false,
      types: ["همه", "پرداخت شده", "برگشت خورده"],
      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      excelFields: [
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "ppkCode", label: "کد پرداخت" },
        { field: "amount", label: "مبلغ پرداخت شده(ریال)" },
        { field: "type", label: "نوع پرداخت" },
        { field: "status", label: "وضعیت" },
        { field: "description", label: "توضیحات" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "زمان" },
      ],
      TotalRows: "",
      codeFilter: "",
      nameFilter: "",
      typeFilter: "همه",
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      userInput: "",
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      T: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      busy: false,
      filter: null,
      selected: "",
      progress: false,
      customer: {},
      paymentsFields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "ppkCode", label: "کد پرداخت" },
        { key: "amount", label: "مبلغ پرداخت شده" },
        { key: "type", label: "نحوه پرداخت" },
        { key: "status", label: "وضعیت" },
        { key: "description", label: "توضیحات" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "زمان" },
        { key: "operation", label: "عملیات" },
      ],
      paymentsFieldsPrint: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "incomeId", label: "کد پرداخت" },
        { key: "amount", label: "مبلغ پرداخت شده" },
        { key: "type", label: "نحوه پرداخت" },
        { key: "status", label: "وضعیت" },
        { key: "description", label: "توضیحات" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "زمان" },
      ],
      paymentsList: [],
      editPaymentDialog: false,
      detailsDialog: false,
      payment: {},
      gettingCustomers: false,
      newPayment: {
        customerBalance: "",
        newPaymentBalance: "",
      },
      customerBalanceData: "",
      gettingBalance: false,
      selectedId: "",
      newDialog: false,
    };
  },

  methods: {
    openPayModal() {
      this.newDialog = true;
      this.newPaymentOpen = true;
    },
    addPayment() {
      this.newPaymentOpen = false;
      this.searchPayments();
    },
    closeNewPayment() {
      this.newPaymentOpen = false;
    },
    submitEditDialog() {
      this.editPaymentOpen = false;
      this.searchPayments();
    },
    closeDetailsDialog() {
      this.editPaymentOpen = false;
    },
    openDetailsDialog(id) {
      this.editPaymentOpen = true;
      this.selectedId = id;
      this.detailsDialog = true;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    searchPayments() {
      this.isBusy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/incomes",
        {
          shopCustomerId: this.selected,
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.paymentsList = res.data;
            this.TotalRows = this.paymentsList.length;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy = false;
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
  },
  computed: {
    computedPayments() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.paymentsList.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.ppkCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      } else {
        filtered = this.paymentsList.filter(
          (x) =>
            x.status == this.typeFilter &&
            x.shopCustomerName.includes(this.nameFilter) &&
            x.ppkCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      }
      return filtered;
    },
  },

  mounted() {
    this.searchPayments();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.middle {
  text-align: center;
}
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
.v-menu__content {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  margin-top: 10px;
}
.payments {
  .custom-input {
    .v-input__slot {
      width: 210px !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #4ba0e7 !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
  .customSelect2 {
    padding-bottom: 10px;
    .v-input__slot {
      width: 120px !important;
    }
    .v-select__selection--comma {
      font-size: 14px !important;
    }
  }
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}
@media print {
  td {
    font-family: "iransans" !important;
    border-radius: 3px;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
